import { createContext, useContext } from 'react';

const app_variant = process.env.REACT_APP_APP_VARIANT ? process.env.REACT_APP_APP_VARIANT : "savori";

const AppVariantContext = createContext(app_variant);

export const useAppVariant = () => useContext(AppVariantContext);

export default AppVariantContext;
